import React from 'react';
import Header from "../Components/Commons/Header";
import {Outlet} from "react-router-dom";
import Nav from "../Components/Commons/Nav";

const AppLayout = (props) => {

    return (
        <>
            <Header
                {...props}
            />
            <div className="main">
                <div className="container">
                    <div className="main_wrapper">
                        <div className={'sidebar'}>
                            <Nav {...props}/>
                        </div>
                        <div className="pages">
                            <Outlet/>
                        </div>
                    </div>
                </div>
            </div>
            <footer className={'footer'}>
                <div className="container">
                    <div className="footer_wrapper">
                        <p className={'footer_copyright'}>©Coldware Innovations, 2025. All rights reserved.</p>
                        <p className={'footer_disclaimer'}>Disclaimer. Cryptocurrency may be unregulated in your
                            jurisdiction. The value of cryptocurrencies may fluctuate. Profits may be subject to capital
                            gains or other taxes applicable in your jurisdiction.</p>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default AppLayout;